import api from "../services/api";

export const fetchPackageEvidencesByPackageId = async (packageId) => {
  try {
    const response = await api.get(`/package-evidence-management/${packageId}`);

    if (response.status === 200) {
      const list = response?.data?.data?.data?.data ?? [];
      return {
        data: Array.isArray(list) ? list : [],
      };
    } else {
      console.warn("Unexpected response:", response);
      return { error: "Unexpected response from server" };
    }
  } catch (error) {
    console.error(
      "Error fetching package evidences by package id:",
      error.message || error
    );

    const errorMessage =
      error.response?.data?.detail ||
      error.message ||
      "Failed to fetch package evidences";

    return { error: errorMessage };
  }
};
